/**
    商品列表
**/
<template>
        <div class="rightaside_content">
          <h3 class="headerTitle">商品评价</h3>
          <el-tabs type="border-card">
            <el-tab-pane label="待评价商品">
                 <span slot="label">待评价商品 <i>( {{listTotal}} )</i></span>
                 <el-row :gutter="20">
                     <el-col :span="8" v-for="(goodItem, goodeIndex) in goodsList" :key="goodeIndex">
                        <div class="wholeInfoBox" >
                             <div>
                                <el-image class="wholeInfoBoxImg" :src="goodItem.photos">
                                    <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                </el-image>
                                <div class="goodsText">
                                    <router-link :to="`/goodsdetail?id=${goodItem.commodityId}`"><p  class="OneLineDisplay">{{goodItem.name}}</p></router-link>
                                    <!-- <p class="OneLineDisplay" style="color:#ff6700;margin:3px 0">{{goodItem.realprice}} 元</p> -->
                                    <p class="OneLineDisplay">{{goodItem.evaluationCount||0}} 人评价</p>
                                 <div class="mark">
                                    <div class="redeemNow" @click="$router.push(`/gotoEvaluation?orderNumber=${goodItem.orderNumber}&goodsId=${goodItem.commodityId}&oid=${goodItem.oid}`)">去评价</div> 
                                </div>  
                                </div>
                            </div>
                        </div>             
                     </el-col>
                     <el-col>
                         <div class="pagination" v-if="goodsList.length!=0">
                                <!-- 分页组件 -->
                                <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
                        </div> 
                     </el-col>
                     <el-col  v-if="goodsList.length==0?true:false">
                          <div class="no_goods">
                            <el-image :src="require('@/assets/img/no_goods.png')" fit="fill">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                            </el-image>
                            <p>暂无您的评价商品</p>
                            <p>可以去看看哪些想要买的</p>
                            <router-link to="/"><p  class="OneLineDisplay">随便逛逛</p></router-link> 
                        </div>
                     </el-col>
                 </el-row>
                
            </el-tab-pane>
            <el-tab-pane label="已评价商品">
                <span slot="label">已评价商品 <i>( {{alreadyList.length}} )</i></span>
                 <el-row :gutter="20">
                     <el-col :span="8" v-for="(item, index ) in alreadyList" :key="index">
                        <div class="wholeInfoBox">
                             <div>
                                <el-image :src="item.commodityImage">
                                    <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                </el-image>
                                <div class="goodsText">
                                    <router-link :to="`/goodsdetail?id=${item.goodId}`"><p  class="OneLineDisplay">{{item.goodsName}}</p></router-link>
                                    <!-- <p class="OneLineDisplay" style="color:#ff6700;margin:3px 0">{{item.realprice||0}} 元</p> -->
                                    <p class="OneLineDisplay">{{item.evaluationCount||0}} 人评价</p>
                                 <div class="mark">
                                    <div class="redeemNow" @click="$router.push(`/evaluationDetail?evaluationId=${item.bXyDoeid}&goodId=${item.goodId}&oid=${item.oid}`)">查看评价详情</div> 
                                </div>  
                                </div>
                            </div>                            
                        </div>                
                     </el-col>
                     <el-col  v-if="alreadyList.length==0?true:false">
                          <div class="no_goods">
                            <el-image :src="require('@/assets/img/no_goods.png')" fit="fill">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                            </el-image>
                            <p>暂无您的评价商品</p>
                            <p>可以去看看哪些想要买的</p>
                            <router-link to="/"><p  class="OneLineDisplay">随便逛逛</p></router-link> 
                        </div>
                     </el-col>
                 </el-row>
            </el-tab-pane>
            <!-- <el-tab-pane label="评价失效商品">
                <span slot="label">评价失效商品 </span>
                <div class="no_goods">
                    <el-image :src="require('@/assets/img/no_goods.png')" fit="fill">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                    </el-image>
                    <p>暂无您的评价商品</p>
                    <p>可以去看看哪些想要买的</p>
                    <router-link to="/"><p  class="OneLineDisplay">随便逛逛</p></router-link> 
                </div>
            </el-tab-pane> -->
            </el-tabs>
        </div>
</template>
<script>
import Pagination from '@/components/Pagination'
import {commentList,evaluateCommodityList} from '@/api/xunyou'
export default {
  data() {
    return {
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        goodsList:[],
        alreadyList:[],
        listTotal:0,
        // 请求数据参数
        formInline: {
            pageSize: 10,
            pageNum: 1,
            muid:JSON.parse(localStorage.getItem("userdata")).userId,
        },
         // 分页参数
        pageparm:{
            pageSize:10,
            currentPage:1,
            total:0,
        },
        
    };
  },
  // 注册组件
  components: {Pagination},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
      this.getGoodsList()
      this.getNoList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
       // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getNoList()
    },
      // 商品已评价查询
     getGoodsList(){
         this.loading =true
        commentList({
            type:2,
            uid:this.userInfo.userId,
            bXyDoeid:671
        })
            .then(res => {
              if (res.code == 0) {
                  this.alreadyList = res.rows
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('查询商品评价失败，请稍后再试！')
            })
      },
    
    // 未评价列表
     getNoList(){
         this.loading =true
        evaluateCommodityList(this.formInline)
            .then(res => {
              if (res.code == 0) {
                  this.goodsList = res.rows
                  this.listTotal = res.total
                  // 分页赋值
                this.pageparm.currentPage = this.formInline.pageNum
                this.pageparm.pageSize = this.formInline.pageSize
                this.pageparm.total = res.total
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('查询失败，请稍后再试！')
            })
      },
  },
};
</script>

<style scoped lang="less">


// .rightaside{
//     background: white;
//     margin-left: 15px;
//     padding: 20px !important;
    .rightaside_content{
        .headerTitle{
           font-size: 20px;
            height: 40px;
            line-height: 40px;
            color: #666;
        }
        /deep/.el-tabs--border-card{
            border: 0px;
            box-shadow: unset;
            .el-tabs__header{
                border-bottom: 0px;
                background: white;
               /deep/ .el-tabs__item.is-active {
                    color:  #ff6700;
                    background-color: transparent;
                    border-right-color: transparent;
                    border-left-color: transparent;
                }
            }
        }

        .wholeInfoBox{
            width: 80%;
            height: auto;
            margin-bottom: 50px;
            .el-image{
                width: 200px;
                height: 200px;
                background: #e6e6e6
            }
            .goodsText {
                text-align: center;
                margin-bottom: 4px;
            }
             .mark{
                display: none;
                font-size: 14px;
                background: rgba(255, 255, 255, 0.8);
                position: relative;
                .redeemNow {
                        background: #ff6700;
                        padding: 6px;
                        text-align: center;
                        color: white;
                        cursor: pointer;
                        position: absolute;
                        left: 50%;
                        transform: translate(-50%);
                        border-radius: 6px;
                }
                .redeemNow:hover{
                    background-color: rgba(34, 34, 34, 0.85);
                }
            }
        }
        .wholeInfoBox:hover{
             .mark{
                display: block;
            }
        }

        .tab_pane_content{
            .noData{
                text-align: center;
                height: 200px;
                line-height: 200px;
            }
        }

        .no_goods {
            text-align: center;
            line-height: 24px;
            font-size: 14px;
        }
    }
// }
.pagination{
  text-align: right;
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #ff6700;
      color: #FFF;
      width: 20px;
  }
  /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li {
    width: 20px;
  }
  /deep/input[disabled], input[disabled="disabled"], input[readonly], input[readonly="readonly"] {
      background-color: transparent;
  }
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/goodsAppraisal.vue